<template>
  <AmTypography
    :text="$t('amAdminDeactivateAppModal.content')"
  />
  <AmTypography
    :text="$t('amAdminDeactivateAppModal.warning')"
    class="mt-2"
  />

  <div :class="mq.current === 'mobile' ? 'flex flex-col gap-2 mt-4' : 'flex justify-end gap-2 mt-4'">
    <AmButton
      :label="$t('amAdminDeactivateAppModal.cancel')"
      variant="maxGhost"
      :disabled="loading"
      data-test="admin-deactivate-cancel"
      @click="emit('cancel')"
    />
    <AmButton
      :label="$t('amAdminDeactivateAppModal.confirm')"
      variant="maxPrimary"
      :disabled="loading"
      data-test="admin-deactivate-confirm"
      @click="emit('confirm')"
    />
  </div>
</template>

<script setup>
import { AmButton, AmTypography } from '@appmax_npm/ds-appmax-v3'
import { inject } from 'vue'

defineProps({
  loading: {
    type: Boolean,
    default: false
  }
})

const mq = inject('mq')
const emit = defineEmits(['confirm', 'cancel'])
</script>
